(() => {
  const moduleName = 'newsletterSettings';

  App[moduleName] = (() => {
    const buildForm = function () {
      // eslint-disable-next-line no-new
      new App.Form(App.forms.newsletterSettings, $('#newsletters-settings-form'));
    };

    const init = function () {
      buildForm();
      App.forms.newsletterSettings.handleWrongHash();
    };

    return {
      init,
    };
  })();
})();
